export const CDP_EVENT_TYPE = {
  fileEntered: 'File Entered',
  fileExited: 'File Exited',
  webFileEntered: 'Web File Entered',
  webFileExited: 'Web File Exited',
  pageEntered: 'Page Entered',
  pageExited: 'Page Exited',
  pageViewed: 'Page Viewed',
  appEntered: 'App Entered',
  appExited: 'App Exited',
  canvasEntered: 'Canvas Entered',
  canvasExited: 'Canvas Exited',
  wizardEntered: 'Wizard Entered',
  wizardExited: 'Wizard Exited',
  canvasShared: 'Canvas Shared',
  customerSentimentCaptured: 'Customer Sentiment Captured',
  canvasPageEntered: 'Canvas Page Entered',
  canvasPageExited: 'Canvas Page Exited',
  canvasComponentEntered: 'Canvas Component Entered',
  canvasComponentExited: 'Canvas Component Exited',
  canvasFileDownloaded: 'Canvas File Downloaded',
  canvasDownloaded: 'Canvas Downloaded',
  userFeedbackCaptured: 'User Feedback Captured',
  userBugReported: 'User Bug Reported',
  userFileReviewed: 'User File Reviewed',
  hotspotClicked: 'Hotspot Clicked',
  collectionPlayerContentChanged: 'Collection Player Content Changed',
  commentAdded: 'Comment Added',
  commentReplied: 'Comment Replied',
  commentAssigned: 'Comment Assigned',
  commentResolved: 'Comment Resolved',
  commentDeleted: 'Comment Deleted',
  algoliaSearchPerformed: 'Algolia Search Performed',
  algoliaSearchNoResults: 'Algolia Search No Results',
  algoliaSearchResultClicked: 'Algolia Search Result Clicked',
} as const

export const CLIENT_TYPE = {
  admin: 'admin',
  impact: 'impact',
  dsr: 'dsr',
  impactCanvasHome: 'impact-canvas-home',
} as const

export const DSR_TYPE = {
  file: 'file',
  canvas: 'canvas',
} as const

export const PLATFORM_TYPE = {
  web: 'web',
  ios: 'ios',
  android: 'android',
  windows: 'windows',
} as const

export const EMBED_TYPE = {
  standalone: 'standalone',
  iframe: 'iframe',
  sfdc: 'sfdc',
  pwa: 'pwa',
} as const

export interface TrackingEvent {
  event_name: string
  payload: any
}

export const TRACKING_EVENTS_STORAGE_KEY = 'tracking_events' as const
